<template>
    <div class="container-shape">
        <div class="box" v-show="pageLoaded">
            <div class="shape-container">
                <!-- Main SVG Path -->
                <svg width="394" height="465" viewBox="0 0 394 465" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path ref="pathRef"
                        d="M392.985 319.814C392.985 334.757 385.156 348.621 372.314 356.369L207.637 455.767C190.248 466.273 168.538 466.753 150.697 457.041L34.0167 393.583C13.7068 382.537 1.06022 361.345 1.06022 338.309L1 145.164C1 130.221 8.82886 116.358 21.6712 108.609L186.348 9.24107C203.737 -1.26524 225.417 -1.75983 243.288 7.95214L359.983 71.4097C380.293 82.4555 392.925 103.663 392.94 126.699L393 319.814H392.985Z"
                        stroke="#9B9AA1" stroke-opacity="0.5" stroke-miterlimit="10" stroke-width="2" />
                </svg>

                <!-- Animated Shape -->
                <div class="rotating-shape" ref="shapeRef">
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="36" height="36" rx="11.88" fill="#5854FF" />
                        <!-- Current Icon -->
                        <g class="icon-container current-icon" ref="currentIconRef">
                            <path
                                d="M5.48163 12.9017C4.30247 13.6034 1.2108 15.0367 3.09413 16.8309C4.0133 17.7067 5.03747 18.3334 6.32497 18.3334H13.6733C14.9616 18.3334 15.9858 17.7067 16.905 16.8309C18.7883 15.0367 15.6966 13.6034 14.5175 12.9017C13.149 12.0932 11.5886 11.6668 9.99913 11.6668C8.40967 11.6668 6.85014 12.0932 5.48163 12.9017ZM13.75 5.41669C13.75 6.41125 13.3549 7.36508 12.6516 8.06834C11.9484 8.7716 10.9945 9.16669 9.99997 9.16669C9.00541 9.16669 8.05158 8.7716 7.34832 8.06834C6.64506 7.36508 6.24997 6.41125 6.24997 5.41669C6.24997 4.42213 6.64506 3.4683 7.34832 2.76504C8.05158 2.06178 9.00541 1.66669 9.99997 1.66669C10.9945 1.66669 11.9484 2.06178 12.6516 2.76504C13.3549 3.4683 13.75 4.42213 13.75 5.41669Z"
                                stroke="white" stroke-linecap="round" stroke-linejoin="round"
                                transform="translate(8, 9)" />
                        </g>
                        <!-- Next Icon (for smooth transition) -->
                        <g class="icon-container next-icon" ref="nextIconRef" style="opacity: 0;">
                            <path
                                d="M5.48163 12.9017C4.30247 13.6034 1.2108 15.0367 3.09413 16.8309C4.0133 17.7067 5.03747 18.3334 6.32497 18.3334H13.6733C14.9616 18.3334 15.9858 17.7067 16.905 16.8309C18.7883 15.0367 15.6966 13.6034 14.5175 12.9017C13.149 12.0932 11.5886 11.6668 9.99913 11.6668C8.40967 11.6668 6.85014 12.0932 5.48163 12.9017ZM13.75 5.41669C13.75 6.41125 13.3549 7.36508 12.6516 8.06834C11.9484 8.7716 10.9945 9.16669 9.99997 9.16669C9.00541 9.16669 8.05158 8.7716 7.34832 8.06834C6.64506 7.36508 6.24997 6.41125 6.24997 5.41669C6.24997 4.42213 6.64506 3.4683 7.34832 2.76504C8.05158 2.06178 9.00541 1.66669 9.99997 1.66669C10.9945 1.66669 11.9484 2.06178 12.6516 2.76504C13.3549 3.4683 13.75 4.42213 13.75 5.41669Z"
                                stroke="white" stroke-linecap="round" stroke-linejoin="round"
                                transform="translate(8, 9)" />
                        </g>
                    </svg>
                </div>
            </div>

            <div class="shapes-conteiner">
                <div class="animtion-ripple-container" aria-hidden="true">
                    <span class="ripple"></span>
                    <span class="ripple"></span>
                    <span class="ripple"></span>
                    <span class="ripple"></span>
                </div>
                <FirstShapHeroSection :startAnimitionShapeOne="startAnimitionShapeOne" />

                <SecondHeroSection :startAnimitionShapeTwo="startAnimitionShapeTwo" />
                <ThirdShapHeroSection :startAnimitionShapeThree="startAnimitionShapeThree" />
                <FourthShapHeroSection :startAnimitionShapeFour="startAnimitionShapeFour" />
                <FifthShapHeroSection :startAnimitionShapeFive="startAnimitionShapeFive" />
            </div>
            <div class="first-step step-box">
                <span>
                    طلب خدمة تقييم للموقع


                    <div class="loader"></div>
                </span>

                <span>
                    <span>تم استلام الطلب بنجاح</span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.16699 11.6667L7.08366 14.5834L15.8337 5.41669" stroke="#615F5F"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </span>
            </div>
            <div class="second-step step-box ">
                <span>
                    عرض الطلب على المقيمين
                    <div class="loader"></div>

                </span>

                <span>
                    <span>تم استلام الطلب من المقيمين</span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.16699 11.6667L7.08366 14.5834L15.8337 5.41669" stroke="#615F5F"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </span>
            </div>

            <div class="third-step step-box ">
                <span>
                    بدء تنفــــــيذ التقــــــــييم
                    <div class="loader"></div>

                </span>

                <span>
                    <span>تسجيل التقييمات بالأداة</span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.16699 11.6667L7.08366 14.5834L15.8337 5.41669" stroke="#615F5F"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </span>
            </div>
            <div class="fourth-step step-box  ">
                <span>
                    تم تحويل الطلب للمراجعة
                    <div class="loader"></div>

                </span>

                <span>
                    <span>مراجعة التقييم من قبل المدقق</span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.16699 11.6667L7.08366 14.5834L15.8337 5.41669" stroke="#615F5F"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </span>
            </div>


            <!-- Particle Effect Above Fifth Step -->
            <div class="fifth-step step-box  ">

                <span>
                    اعتماد نتائج التقــــييم
                    <div class="loader"></div>

                </span>
                <div class="particle-effect-container" ref="particleEffectRef" v-show="showParticleEffect">
                    <div class="particle-burst" v-for="burst in 3" :key="burst" :class="`burst-${burst}`">
                        <div class="particle" v-for="particle in 25" :key="particle" :class="`particle-${particle}`"
                            :style="{ '--particle-delay': `${particle * 0.02}s`, '--particle-angle': `${particle * 14.4}deg` }">
                        </div>
                    </div>
                </div>
                <span>
                    <span>تم ارسال التقرير النهائي</span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.16699 11.6667L7.08366 14.5834L15.8337 5.41669" stroke="#615F5F"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </span>
            </div>
        </div>
        <p>
        رحلة طلب رأي خبير
        (الأكسبرت)
        </p>
    </div>

</template>

<script setup lang="ts">
import { onMounted, ref, nextTick, onBeforeUnmount, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
// Import the separated components
import FirstShapHeroSection from '@/components/ui/hero/FirstShapHeroSection.vue'
import SecondHeroSection from '@/components/ui/hero/SecondHeroSection.vue'
import ThirdShapHeroSection from '@/components/ui/hero/ThirdShapHeroSection.vue'
import FourthShapHeroSection from '@/components/ui/hero/FourthShapHeroSection.vue'
import FifthShapHeroSection from '@/components/ui/hero/FifthShapHeroSection.vue'

// ===== ROUTER SETUP =====
const route = useRoute()

const startAnimitionShapeOne = ref(false)
const startAnimitionShapeTwo = ref(false)
const startAnimitionShapeThree = ref(false)
const startAnimitionShapeFour = ref(false)
const startAnimitionShapeFive = ref(false)

// ===== TYPE DEFINITIONS =====
interface AnimationConfig {
    speed: number
    svgWidth: number
    svgHeight: number
    stopDuration: number
}

interface AnimationState {
    progress: number
    pathLength: number
    isAnimating: boolean
    isStopping: boolean
}

interface Point {
    x: number
    y: number
}

// ===== REFERENCES =====
const pathRef = ref<SVGPathElement>()
const shapeRef = ref<HTMLElement>()
const currentIconRef = ref<SVGGElement>()
const nextIconRef = ref<SVGGElement>()
const particleEffectRef = ref<HTMLElement>()
const pageLoaded = ref(false)
const showParticleEffect = ref(false)

// ===== STATE =====
const isStopping = ref(false)
const currentIconIndex = ref(0)
const eventsTriggered = ref<boolean[]>([false, false, false, false, false])

// ===== CLEANUP TRACKING =====
const activeTimeouts = ref<NodeJS.Timeout[]>([])
const animationFrameId = ref<number | null>(null)
const isComponentDestroyed = ref(false)

// ===== CONFIGURATION =====
const ANIMATION_CONFIG: AnimationConfig = {
    speed: 0.0045,
    svgWidth: 394,
    svgHeight: 465,
    stopDuration: 2000
}

// ===== STOP POINTS =====
const STOP_POINTS = [0.9, 0.1, 0.3, 0.45, 0.6] // 5 stops around the shape

// ===== STOP DURATIONS =====
const STOP_DURATIONS = [8000, 2000, 10500, 3000, 3000] // Different durations for each stop point

// ===== CLEANUP UTILITY FUNCTIONS =====

/**
 * Creates a timeout that tracks itself for cleanup
 * @param callback - Function to execute
 * @param delay - Delay in milliseconds
 * @returns Timeout ID
 */
const createManagedTimeout = (callback: () => void, delay: number): NodeJS.Timeout => {
    const timeoutId = setTimeout(() => {
        if (!isComponentDestroyed.value) {
            callback()
        }
        // Remove from active timeouts
        const index = activeTimeouts.value.indexOf(timeoutId)
        if (index > -1) {
            activeTimeouts.value.splice(index, 1)
        }
    }, delay)

    activeTimeouts.value.push(timeoutId)
    return timeoutId
}

/**
 * Clears all active timeouts
 */
const clearAllTimeouts = (): void => {
    activeTimeouts.value.forEach(timeoutId => {
        clearTimeout(timeoutId)
    })
    activeTimeouts.value = []
}

/**
 * Stops all animations and clears resources
 */
const stopComponent = (): void => {

    // Mark component as destroyed
    isComponentDestroyed.value = true

    // Stop animation
    animationState.isAnimating = false
    animationState.isStopping = false
    isStopping.value = false

    // Clear animation frame
    if (animationFrameId.value) {
        cancelAnimationFrame(animationFrameId.value)
        animationFrameId.value = null
    }

    // Clear all timeouts
    clearAllTimeouts()

    // Hide particle effect if active
    showParticleEffect.value = false
    if (particleEffectRef.value) {
        particleEffectRef.value.classList.remove('active')
    }

    // Reset all shape animations
    startAnimitionShapeOne.value = false
    startAnimitionShapeTwo.value = false
    startAnimitionShapeThree.value = false
    startAnimitionShapeFour.value = false
    startAnimitionShapeFive.value = false

    // Reset all step classes
    const steps = ['.first-step', '.second-step', '.third-step', '.fourth-step', '.fifth-step']
    const classes = ['show', 'show-reverse', 'cheked', 'end', 'end-reverse']

    steps.forEach(stepSelector => {
        const stepElement = document.querySelector(stepSelector)
        if (stepElement) {
            classes.forEach(className => {
                stepElement.classList.remove(className)
            })
        }
    })

    // Reset events triggered
    eventsTriggered.value = [false, false, false, false, false]

}

/**
 * Restarts the component animation
 */
const restartComponent = async (): Promise<void> => {

    // Stop current animation
    stopComponent()

    // Wait a moment for cleanup to complete
    await new Promise(resolve => setTimeout(resolve, 100))

    // Reset destroyed flag
    isComponentDestroyed.value = false

    // Restart animation
    await nextTick()
    await initializeAnimation()

}

// ===== STOP POINT EVENTS =====
const STOP_POINT_EVENTS = [
    // Event for stop point 1 (0.9)
    () => {
        if (isComponentDestroyed.value) return

        startAnimitionShapeOne.value = true;
        startAnimitionShapeFive.value = false;
        createManagedTimeout(() => {
            document.querySelector('.first-step')?.classList.add('show')
        }, 200);
        createManagedTimeout(() => {
            document.querySelector('.first-step')?.classList.add('cheked')
        }, STOP_DURATIONS[0] + 200);
        createManagedTimeout(() => {
            document.querySelector('.first-step')?.classList.add('end')
        }, STOP_DURATIONS[0] + 1500);

    },

    // Event for stop point 2 (0.1)
    () => {
        if (isComponentDestroyed.value) return

        startAnimitionShapeOne.value = false;
        startAnimitionShapeTwo.value = true
        createManagedTimeout(() => {
            document.querySelector('.second-step')?.classList.add('show')
        }, 300);

        createManagedTimeout(() => {
            document.querySelector('.second-step')?.classList.add('cheked')
        }, STOP_DURATIONS[1]);
        createManagedTimeout(() => {
            document.querySelector('.second-step')?.classList.add('end')
        }, STOP_DURATIONS[1] + 1500);
    },

    // Event for stop point 3 (0.3)
    () => {
        if (isComponentDestroyed.value) return

        startAnimitionShapeTwo.value = false;
        startAnimitionShapeThree.value = true
        createManagedTimeout(() => {
            document.querySelector('.third-step')?.classList.add('show-reverse')
        }, 300);

        createManagedTimeout(() => {
            document.querySelector('.third-step')?.classList.add('cheked')
        }, STOP_DURATIONS[2]);
        createManagedTimeout(() => {
            document.querySelector('.third-step')?.classList.add('end-reverse')
        }, STOP_DURATIONS[2] + 1500);
    },

    // Event for stop point 4 (0.45)
    () => {
        if (isComponentDestroyed.value) return

        startAnimitionShapeThree.value = false;
        startAnimitionShapeFour.value = true
        createManagedTimeout(() => {
            document.querySelector('.fourth-step')?.classList.add('show-reverse')
        }, 300);
        createManagedTimeout(() => {
            document.querySelector('.fourth-step')?.classList.add('cheked')
        }, STOP_DURATIONS[3]);
        createManagedTimeout(() => {
            document.querySelector('.fourth-step')?.classList.add('end-reverse')
        }, STOP_DURATIONS[3] + 1500);
    },

    // Event for stop point 5 (0.6)
    () => {
        if (isComponentDestroyed.value) return

        startAnimitionShapeFour.value = false;
        startAnimitionShapeFive.value = true
        createManagedTimeout(() => {
            document.querySelector('.fifth-step')?.classList.add('show-reverse')
        }, 300);
        createManagedTimeout(() => {
            document.querySelector('.fifth-step')?.classList.add('cheked')
        }, STOP_DURATIONS[4] + 200);
        createManagedTimeout(() => {
            document.querySelector('.fifth-step')?.classList.add('end-reverse')
        }, STOP_DURATIONS[4] + 1500);

        // Trigger particle effect when fifth step gets 'end-reverse' class
        createManagedTimeout(() => {
            if (!isComponentDestroyed.value) {
                showParticleEffect.value = true;
                particleEffectRef.value?.classList.add('active');
            }
        }, STOP_DURATIONS[4] + 1600);

        // Hide particle effect after 4 seconds
        createManagedTimeout(() => {
            if (!isComponentDestroyed.value) {
                showParticleEffect.value = false;
                particleEffectRef.value?.classList.remove('active');
            }
        }, STOP_DURATIONS[4] + 5600);

        // Reset all steps
        createManagedTimeout(() => {
            if (!isComponentDestroyed.value) {
                document.querySelector('.first-step')?.classList.remove('show')
                document.querySelector('.first-step')?.classList.remove('cheked')
                document.querySelector('.first-step')?.classList.remove('end')
                document.querySelector('.second-step')?.classList.remove('show')
                document.querySelector('.second-step')?.classList.remove('cheked')
                document.querySelector('.second-step')?.classList.remove('end')
                document.querySelector('.third-step')?.classList.remove('show-reverse')
                document.querySelector('.third-step')?.classList.remove('cheked')
                document.querySelector('.third-step')?.classList.remove('end-reverse')
                document.querySelector('.fourth-step')?.classList.remove('show-reverse')
                document.querySelector('.fourth-step')?.classList.remove('cheked')
                document.querySelector('.fourth-step')?.classList.remove('end-reverse')
                document.querySelector('.fifth-step')?.classList.remove('show-reverse')
                document.querySelector('.fifth-step')?.classList.remove('cheked')
                document.querySelector('.fifth-step')?.classList.remove('end-reverse')
            }
        }, STOP_DURATIONS[4] + 6500);
    }
]

// ===== ICONS DATA =====
const ICONS = [
    // Icon 1 - User
    '<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.48163 11.9017C2.30247 12.6034 -0.789199 14.0367 1.09413 15.8309C2.0133 16.7067 3.03747 17.3334 4.32497 17.3334H11.6733C12.9616 17.3334 13.9858 16.7067 14.905 15.8309C16.7883 14.0367 13.6966 12.6034 12.5175 11.9017C11.149 11.0932 9.5886 10.6668 7.99913 10.6668C6.40967 10.6668 4.85014 11.0932 3.48163 11.9017ZM11.75 4.41669C11.75 5.41125 11.3549 6.36508 10.6516 7.06834C9.94836 7.7716 8.99453 8.16669 7.99997 8.16669C7.00541 8.16669 6.05158 7.7716 5.34832 7.06834C4.64506 6.36508 4.24997 5.41125 4.24997 4.41669C4.24997 3.42213 4.64506 2.4683 5.34832 1.76504C6.05158 1.06178 7.00541 0.666687 7.99997 0.666687C8.99453 0.666687 9.94836 1.06178 10.6516 1.76504C11.3549 2.4683 11.75 3.42213 11.75 4.41669Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>',

    // Icon 2 - Document with eye
    '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.4987 9.41913C16.4987 9.41913 16.5003 9.02746 16.5003 8.58579C16.5003 4.85246 16.5003 2.98579 15.3412 1.82663C14.182 0.667459 12.3162 0.666626 8.58366 0.666626C4.85199 0.666626 2.98533 0.666626 1.82616 1.82663C0.666992 2.98663 0.666992 4.85246 0.666992 8.58496C0.666992 12.3183 0.666992 14.185 1.82616 15.345C2.79866 16.3175 4.26783 16.475 6.91699 16.5M0.666992 4.83329H16.5003M4.00033 12.3333H4.83366M7.33366 8.99996H11.5003M4.00033 8.99996H4.83366M13.167 14.4166H13.1745" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.1433 14.0192C17.27 14.1967 17.3333 14.2858 17.3333 14.4167C17.3333 14.5483 17.27 14.6367 17.1433 14.8142C16.5742 15.6125 15.1208 17.3333 13.1667 17.3333C11.2125 17.3333 9.75917 15.6125 9.19 14.8142C9.06333 14.6367 9 14.5475 9 14.4167C9 14.285 9.06333 14.1967 9.19 14.0192C9.75917 13.2208 11.2125 11.5 13.1667 11.5C15.1208 11.5 16.5742 13.2208 17.1433 14.0192Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>',

    // Icon 3 - Chat with edit
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.9965 9.99996H10.0032M6.6665 9.99996H6.674M18.3332 9.63913C18.3332 14.0416 14.6015 17.6108 9.99984 17.6108C9.45706 17.6113 8.91956 17.5619 8.38734 17.4625C8.00484 17.39 7.814 17.3541 7.68067 17.375C7.54734 17.395 7.35734 17.4958 6.979 17.6966C5.90096 18.2708 4.66051 18.4637 3.459 18.2441C3.91796 17.6768 4.22918 17.0045 4.36484 16.2875C4.44817 15.8458 4.2415 15.4166 3.9315 15.1025C2.52817 13.6758 1.6665 11.7541 1.6665 9.63913C1.6665 5.23663 5.39817 1.66663 9.99984 1.66663C10.5721 1.66774 11.1276 1.72079 11.6665 1.82579" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.3657 2.0633L17.9423 2.6408C18.1767 2.87521 18.3083 3.19309 18.3083 3.52455C18.3083 3.856 18.1767 4.17389 17.9423 4.4083L14.9198 7.4883C14.6821 7.72615 14.3779 7.88651 14.0473 7.9483L12.1732 8.35497C12.105 8.36978 12.0343 8.36726 11.9674 8.34765C11.9005 8.32803 11.8396 8.29194 11.7903 8.24269C11.7409 8.19343 11.7047 8.13259 11.685 8.06572C11.6653 7.99886 11.6626 7.92811 11.6773 7.85997L12.0765 5.99747C12.1383 5.66688 12.2987 5.36273 12.5365 5.12497L15.5973 2.0633C15.7134 1.94714 15.8513 1.855 16.003 1.79213C16.1547 1.72926 16.3173 1.6969 16.4815 1.6969C16.6457 1.6969 16.8083 1.72926 16.96 1.79213C17.1117 1.855 17.2496 1.94714 17.3657 2.0633Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>',

    // Icon 4 - Lock with notification
    '<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.8333 8.16663V7.33329C13.8333 4.19079 13.8333 2.61913 12.8567 1.64329C11.88 0.667459 10.3092 0.666626 7.16667 0.666626C4.02417 0.666626 2.4525 0.666626 1.47667 1.64329C0.500833 2.61996 0.5 4.19079 0.5 7.33329V10.6666C0.5 13.8091 0.5 15.3808 1.47667 16.3566C2.45333 17.3325 4.02417 17.3333 7.16667 17.3333" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.5002 17.3333L14.0718 15.9049M3.8335 4.83325H10.5002M3.8335 8.16659H7.16683M14.5477 13.5241C14.5541 13.9034 14.485 14.2802 14.3444 14.6325C14.2037 14.9848 13.9943 15.3056 13.7283 15.5761C13.4624 15.8466 13.1452 16.0615 12.7954 16.2082C12.4455 16.3548 12.0699 16.4304 11.6906 16.4304C11.3112 16.4304 10.9357 16.3548 10.5858 16.2082C10.2359 16.0615 9.91879 15.8466 9.65284 15.5761C9.3869 15.3056 9.17748 14.9848 9.03681 14.6325C8.89613 14.2802 8.82702 13.9034 8.8335 13.5241C8.84629 12.7748 9.15293 12.0605 9.68735 11.5351C10.2218 11.0098 10.9412 10.7154 11.6906 10.7154C12.44 10.7154 13.1594 11.0098 13.6938 11.5351C14.2282 12.0605 14.5349 12.7748 14.5477 13.5241Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>',

    // Icon 5 - Lock with user
    '<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.8333 7.75002V7.33335C13.8333 4.19085 13.8333 2.61919 12.8567 1.64335C11.88 0.66752 10.3092 0.666687 7.16667 0.666687C4.02417 0.666687 2.4525 0.666687 1.47667 1.64335C0.500833 2.62002 0.5 4.19085 0.5 7.33335V12.3334C0.5 13.8867 0.5 14.6634 0.753333 15.275C0.92085 15.6795 1.1664 16.047 1.47596 16.3566C1.78552 16.6661 2.15303 16.9117 2.5575 17.0792C3.17 17.3334 3.94667 17.3334 5.5 17.3334M3.83333 4.83335H10.5M3.83333 8.16669H7.16667" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.7358 14.8354C10.6858 14.0954 10.5983 13.3038 10.235 12.4088C9.92417 11.6454 10.0108 9.84961 11.75 9.84961C13.4892 9.84961 13.555 11.6454 13.245 12.4079C12.8817 13.3038 12.8133 14.0954 12.765 14.8354M15.5 17.3321H8V16.2938C8 15.9221 8.22167 15.5946 8.54417 15.4929L10.4233 14.8963C10.5578 14.8535 10.695 14.8321 10.835 14.8321H12.665C12.805 14.8321 12.9422 14.8535 13.0767 14.8963L14.9558 15.4929C15.2783 15.5946 15.5 15.9221 15.5 16.2938V17.3321Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>'
]

// ===== ANIMATION STATE =====
let animationState: AnimationState = {
    progress: 0.9, // Start from 0.9 instead of 0
    pathLength: 0,
    isAnimating: false,
    isStopping: false
}

// ===== UTILITY FUNCTIONS =====

/**
 * Converts SVG coordinates to percentage
 * @param x - X coordinate in SVG units
 * @param y - Y coordinate in SVG units
 * @returns Point with x and y as percentages
 */
const convertToPercentage = (x: number, y: number): Point => {
    return {
        x: (x / ANIMATION_CONFIG.svgWidth) * 100,
        y: (y / ANIMATION_CONFIG.svgHeight) * 100
    }
}

/**
 * Checks if we should stop at current progress
 * @param progress - Current animation progress (0-1)
 * @returns boolean indicating if should stop
 */
const shouldStopAtPoint = (progress: number): boolean => {
    return STOP_POINTS.some(stopPoint =>
        Math.abs(stopPoint - progress) < 0.01 && !isStopping.value
    )
}

/**
 * Checks if we should trigger events before stopping (1 second before stop)
 * @param progress - Current animation progress (0-1)
 * @returns boolean indicating if should trigger events
 */
const shouldTriggerEventsBeforeStop = (progress: number): boolean => {
    return STOP_POINTS.some(stopPoint => {
        const distanceToStop = Math.abs(stopPoint - progress)
        return distanceToStop < 0.1 && distanceToStop > 0.05 && !isStopping.value
    })
}

/**
 * Triggers events before reaching stop point
 * @param progress - Current animation progress (0-1)
 */
const triggerEventsBeforeStop = (progress: number): void => {
    STOP_POINTS.forEach((stopPoint, index) => {
        const distanceToStop = Math.abs(stopPoint - progress)
        if (distanceToStop < 0.1 && distanceToStop > 0.05 && !eventsTriggered.value[index]) {
            eventsTriggered.value[index] = true
            try {
                STOP_POINT_EVENTS[index]()
            } catch (error) {
                console.log(error)
            }
        }
    })
}

/**
 * Gets the closest stop point to current progress
 * @param progress - Current animation progress (0-1)
 * @returns The closest stop point value
 */
const getClosestStopPoint = (progress: number): number => {
    let closest = STOP_POINTS[0]
    let minDistance = Math.abs(STOP_POINTS[0] - progress)

    STOP_POINTS.forEach(stopPoint => {
        const distance = Math.abs(stopPoint - progress)
        if (distance < minDistance) {
            minDistance = distance
            closest = stopPoint
        }
    })

    return closest
}

// Add new simple function before animate
const isNearCorner = (progress: number): boolean => {
    const cornerDistance = 0.05; // 5% of path length around each corner
    const normalizedProgress = progress % 1;
    return STOP_POINTS.some(stop => {
        const diff = Math.abs(normalizedProgress - stop);
        return diff < cornerDistance || (1 - diff) < cornerDistance;
    });
};

// ===== ICON MANAGEMENT FUNCTIONS =====

/**
 * Changes the icon in the shape with smooth fade transition
 * @param iconIndex - Index of the icon to change to
 */
const changeIcon = async (iconIndex: number): Promise<void> => {
    if (!currentIconRef.value || !nextIconRef.value) return

    const currentIcon = currentIconRef.value
    const nextIcon = nextIconRef.value

    // Get the new icon SVG content
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = ICONS[iconIndex]
    const newIconElement = tempDiv.firstElementChild as SVGElement

    if (!newIconElement) return

    // Clear next icon and add new content
    nextIcon.innerHTML = ''

    // Clone the new icon and add it to next icon container
    const clonedIcon = newIconElement.cloneNode(true) as SVGElement

    // Center the icon if it has width/height attributes
    const iconWidth = parseInt(newIconElement.getAttribute('width') || '16')
    const iconHeight = parseInt(newIconElement.getAttribute('height') || '18')
    const x = (36 - iconWidth) / 2
    const y = (36 - iconHeight) / 2

    // Apply centering transform
    clonedIcon.style.transform = `translate(${x}px, ${y}px)`

    nextIcon.appendChild(clonedIcon)

    // Start fade transition
    // Fade out current icon
    currentIcon.style.transition = 'opacity 0.3s ease-out'
    currentIcon.style.opacity = '0'

    // Wait for fade out
    await new Promise(resolve => setTimeout(resolve, 300))

    // Fade in next icon
    nextIcon.style.transition = 'opacity 0.3s ease-in'
    nextIcon.style.opacity = '1'

    // Wait for fade in
    await new Promise(resolve => setTimeout(resolve, 300))

    // Swap the icons
    currentIcon.innerHTML = nextIcon.innerHTML
    currentIcon.style.opacity = '1'
    nextIcon.style.opacity = '0'

    // Reset transitions
    currentIcon.style.transition = ''
    nextIcon.style.transition = ''
}

// ===== ANIMATION CONTROL FUNCTIONS =====

/**
 * Updates the shape position and rotation
 * @param path - SVG path element
 * @param shape - HTML element to position
 * @param progress - Animation progress (0-1)
 */
const updateShapePosition = (path: SVGPathElement, shape: HTMLElement, progress: number): void => {
    // Get current point on path
    const point = path.getPointAtLength(progress * animationState.pathLength)

    // Convert to percentage
    const { x, y } = convertToPercentage(point.x, point.y)

    // Apply position (no rotation for now)
    shape.style.left = `${x}%`
    shape.style.top = `${y}%`
    shape.style.transform = 'translate(-50%, -50%)'
}

/**
 * Handles stopping at a point
 * - Stops the animation
 * - Changes the icon
 * - Waits for specified duration
 * - For the last stop point, hides the shape for 5 seconds
 * - Resumes animation
 */
const handleStopAtPoint = async (): Promise<void> => {
    if (isStopping.value) return

    // Get the exact stop point
    let stopPoint = getClosestStopPoint(animationState.progress)

    // Set progress to exact stop point
    animationState.progress = stopPoint

    isStopping.value = true
    animationState.isStopping = true

    // Get the stop index to determine duration and change icon
    const stopIndex = STOP_POINTS.indexOf(stopPoint)
    const stopDuration = stopIndex !== -1 ? STOP_DURATIONS[stopIndex] : ANIMATION_CONFIG.stopDuration

    // Change icon based on current stop point
    if (stopIndex !== -1) {
        currentIconIndex.value = stopIndex
        await changeIcon(stopIndex)
    }

    // Wait for stop duration
    await new Promise(resolve => setTimeout(resolve, stopDuration))

    // If this is the last stop point (index 4), hide for 5 seconds
    if (stopIndex === 4 && shapeRef.value) {
        const shape = shapeRef.value
        shape.style.transition = 'opacity 0.5s ease'
        shape.style.opacity = '0'

        // Wait 5 seconds
        await new Promise(resolve => setTimeout(resolve, 2000))
        stopPoint = 0.8
        await new Promise(resolve => setTimeout(resolve, 4000))

        // Show again
        shape.style.opacity = '1'

    }

    // Resume animation by moving slightly past the stop point
    animationState.progress = stopPoint + 0.01

    isStopping.value = false
    animationState.isStopping = false
}

/**
 * Main animation loop
 * - Checks for stopping points
 * - Updates shape position
 * - Advances progress
 * - Continues animation
 * @param path - SVG path element
 * @param shape - HTML element to animate
 */
const animate = async (path: SVGPathElement, shape: HTMLElement): Promise<void> => {
    if (!animationState.isAnimating || isComponentDestroyed.value) return

    // Check if we should trigger events before stopping
    if (shouldTriggerEventsBeforeStop(animationState.progress)) {
        triggerEventsBeforeStop(animationState.progress)
    }

    // Check for stopping
    if (shouldStopAtPoint(animationState.progress)) {
        await handleStopAtPoint()
    }

    // Update shape position
    updateShapePosition(path, shape, animationState.progress)

    // Update progress only if not stopping
    if (!isStopping.value) {
        // Simple slowdown near corners
        const baseSpeed = ANIMATION_CONFIG.speed;
        const adaptiveSpeed = isNearCorner(animationState.progress) ? baseSpeed - 0.002 : baseSpeed;
        animationState.progress += adaptiveSpeed;
    }

    // Reset progress when complete
    if (animationState.progress >= 1) {
        animationState.progress = 0
        // Reset events triggered when animation restarts
        eventsTriggered.value = [false, false, false, false, false]
    }

    // Continue animation
    if (!isComponentDestroyed.value) {
        animationFrameId.value = requestAnimationFrame(() => animate(path, shape))
    }
}

/**
 * Starts the animation
 * - Initializes path length
 * - Sets starting position
 * - Begins animation loop
 * @param path - SVG path element
 * @param shape - HTML element to animate
 */
const startAnimation = (path: SVGPathElement, shape: HTMLElement): void => {
    // Reset destroyed flag
    isComponentDestroyed.value = false

    // Get path length
    animationState.pathLength = path.getTotalLength()
    // Set initial position to 0.8
    animationState.progress = 0.8

    // Set the shape to the correct starting position immediately
    updateShapePosition(path, shape, 0.8)

    // Start animation
    animationState.isAnimating = true
    animate(path, shape)
}

/**
 * Stops the animation
 */
const stopAnimation = (): void => {
    animationState.isAnimating = false
    stopComponent()
}

// ===== VALIDATION AND INITIALIZATION FUNCTIONS =====

/**
 * Validates that required elements exist
 * @returns Object with path and shape elements, or null if not found
 */
const validateElements = (): { path: SVGPathElement; shape: HTMLElement } | null => {
    const path = pathRef.value
    const shape = shapeRef.value

    if (!path || !shape) {
        console.error('Required elements not found: path or shape')
        return null
    }

    return { path, shape }
}

/**
 * Initializes the animation system
 * - Validates elements
 * - Starts animation
 */
const initializeAnimation = async (): Promise<void> => {
    const elements = validateElements()
    if (!elements) return

    const { path, shape } = elements
    startAnimation(path, shape)
}

// ===== ROUTE CHANGE WATCHER =====
watch(
    () => route.fullPath,
    (newPath, oldPath) => {
        if (newPath !== oldPath) {
            restartComponent()
        }
    }
)

// ===== LIFECYCLE HOOKS =====

onMounted(async () => {
    await nextTick()
    await initializeAnimation()
    pageLoaded.value = true
})

onBeforeUnmount(() => {
    stopComponent()
})

onUnmounted(() => {
    stopComponent()
})

// ===== EXPOSE FUNCTIONS =====
defineExpose({
    startAnimation: () => {
        const elements = validateElements()
        if (elements) startAnimation(elements.path, elements.shape)
    },
    stopAnimation,
    restartComponent,
    updateSpeed: (newSpeed: number) => {
        ANIMATION_CONFIG.speed = newSpeed
    }
})
</script>

<style scoped lang="scss">
.step-box {
    position: absolute;
    background: #5854FF;
    width: fit-content;
    padding: 6px 14px;
    color: white;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    opacity: 0;
    transition: 0.3s ease-in-out;
    border: 1px solid #5854FF;
    transition: 0.3s ease-in-out;
    font-size: 13px;

    &>span:first-child {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        // >svg {
        //     animation: spin 1s linear infinite;
        // }
    }

    &>span:last-child {
        display: none;
    }

}



.loader {
    width: 16px;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 3px solid #ffffff;
    animation: loadone 0.8s infinite linear alternate, loadtwo 1.6s infinite linear;

}

@keyframes loadone {
    0% {
        clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%)
    }

    12.5% {
        clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%)
    }

    25% {
        clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%)
    }

    50% {
        clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
    }

    62.5% {
        clip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
    }

    75% {
        clip-path: polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 100%, 0% 100%)
    }

    100% {
        clip-path: polygon(50% 50%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 0% 100%)
    }
}

@keyframes loadtwo {
    0% {
        transform: scaleY(1) rotate(0deg)
    }

    49.99% {
        transform: scaleY(1) rotate(135deg)
    }

    50% {
        transform: scaleY(-1) rotate(0deg)
    }

    100% {
        transform: scaleY(-1) rotate(-135deg)
    }
}

.step-box.show {
    opacity: 1;
    transform: translateX(-10px);
}

.step-box.show-reverse {
    opacity: 1;
    transform: translateX(10px);

    // transform: translateX(60px);
}

.step-box.show.cheked,
.step-box.show-reverse.cheked {
    background: #fff;
    color: #222;
    border-color: #efefef;
    // transform: translateX(0);

    &>span:first-child {
        display: none;
    }

    &>span:last-child {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
    }
}

.step-box.show.end {
    transform: translateX(30px);
}

.step-box.show-reverse.end-reverse {
    transform: translateX(-30px);
}




.first-step {
    left: -12px;
    top: 212px;
    min-width: 180px;
}

.second-step {
    left: 56px;
    bottom: 120px;
    min-width: 201px;

}

.third-step {
    right: 51px;
    bottom: 107px;
    min-width: 178px;
}

.fourth-step {
    right: -37px;
    bottom: 289px;
    min-width: 205px;
}

.fifth-step {
    top: 112px;
    right: 94px;
    min-width: 164px;

}

.container-shape {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 2rem;
    h6 {
        font-size: var(--fs-md);
        margin: -10px 0 0 0;
    }
}

/* ===== ANIMATION STYLES ===== */
.box {
    width: 750px;
    height: 600px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    //overflow: hidden;
}

.shape-container {
    position: relative;
}

/* ===== ANIMATED SHAPE STYLES ===== */
.rotating-shape {
    position: absolute;
    z-index: 10;
    /* filter: drop-shadow(0 0 8px rgba(88, 84, 255, 0.5)); */
}

.rotating-shape svg {
    width: 36px;
    height: 36px;
}

/* ===== ICON CONTAINER STYLES ===== */
.icon-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.current-icon {
    opacity: 1;
    transition: opacity 0.3s ease-out;
}

.next-icon {
    opacity: 0;
    transition: opacity 0.3s ease-in;
}

/* ===== ICON TRANSITION EFFECTS ===== */
.icon-container svg {
    transition: all 0.3s ease;
}

.icon-container:hover svg {
    transform: scale(1.05);
}

/* ===== FADE TRANSITION EFFECTS ===== */
.fade-out {
    opacity: 0;
    transition: opacity 0.3s ease-out;
}

.fade-in {
    opacity: 1;
    transition: opacity 0.3s ease-in;
}

/* ===== PARTICLE EFFECT STYLES ===== */
.particle-effect-container {
    position: absolute;
    top: -80px;
    left: 50%;
    transform: translateX(-50%);
    width: 200px;
    height: 200px;
    pointer-events: none;
    z-index: 1002;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    display: none;
}

.particle-effect-container.active {
    display: block;
    opacity: 1;
}

.particle-burst {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 8px;
    height: 8px;
    transform: translate(-50%, -50%);
}

.burst-1 {
    animation-delay: 0s;
}

.burst-2 {
    animation-delay: 0.5s;
}

.burst-3 {
    animation-delay: 1s;
}

.particle {
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    opacity: 0;
    transform-origin: center;
    animation: particle-burst 2s ease-out forwards;
    animation-delay: var(--particle-delay);
}

/* Different colored particles */
.particle:nth-child(5n+1) {
    background-color: #FFD700;
}

.particle:nth-child(5n+2) {
    background-color: #FF6B6B;
}

.particle:nth-child(5n+3) {
    background-color: #4ECDC4;
}

.particle:nth-child(5n+4) {
    background-color: #45B7D1;
}

.particle:nth-child(5n+5) {
    background-color: #96CEB4;
}

/* Different particle sizes */
.particle:nth-child(3n+1) {
    width: 8px;
    height: 8px;
}

.particle:nth-child(3n+2) {
    width: 4px;
    height: 4px;
}

.particle:nth-child(7n+1) {
    width: 10px;
    height: 10px;
    border-radius: 2px;
}

@keyframes particle-burst {
    0% {
        opacity: 0;
        transform: translate(-50%, -50%) rotate(var(--particle-angle)) translateX(0) scale(0);
    }

    10% {
        opacity: 1;
        transform: translate(-50%, -50%) rotate(var(--particle-angle)) translateX(20px) scale(1);
    }

    30% {
        opacity: 1;
        transform: translate(-50%, -50%) rotate(var(--particle-angle)) translateX(60px) scale(1.2);
    }

    60% {
        opacity: 0.8;
        transform: translate(-50%, -50%) rotate(var(--particle-angle)) translateX(100px) scale(0.8) translateY(40px);
    }

    100% {
        opacity: 0;
        transform: translate(-50%, -50%) rotate(var(--particle-angle)) translateX(140px) scale(0.3) translateY(120px);
    }
}

.celebration-text {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    opacity: 0;
    animation: celebration-text-appear 0.8s ease-out 0.5s forwards;
}

.success-burst {
    font-size: 48px;
    margin-bottom: 10px;
    animation: bounce-celebration 1s ease-in-out infinite;
}

.celebration-message-text {
    color: #5854FF;
    font-size: 16px;
    font-weight: bold;
    text-shadow: 2px 2px 4px rgba(88, 84, 255, 0.3);
    white-space: nowrap;
}

@keyframes celebration-text-appear {
    0% {
        opacity: 0;
        transform: translateX(-50%) translateY(20px) scale(0.8);
    }

    50% {
        opacity: 1;
        transform: translateX(-50%) translateY(-5px) scale(1.1);
    }

    100% {
        opacity: 1;
        transform: translateX(-50%) translateY(0) scale(1);
    }
}

@keyframes bounce-celebration {

    0%,
    100% {
        transform: scale(1) rotate(-3deg);
    }

    50% {
        transform: scale(1.1) rotate(3deg);
    }
}


.animtion-ripple-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
    pointer-events: none;
    width: 45%;
    height: 42%;

}

.animtion-ripple-container .ripple {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    height: 500px;
    border-radius: 50%;
    opacity: 0.28;
    background: radial-gradient(circle at 50% 50%, rgba(87, 84, 255, 0.657) 0%, rgba(87, 84, 255, 0.328) 45%, rgba(87, 84, 255, 0) 72%);
    filter: blur(12px);
    animation: ripple-twist 10s ease-in-out infinite;
}

.animtion-ripple-container .ripple:nth-child(2) {
    width: 500px;
    height: 500px;
    opacity: 0.2;
    animation-delay: 1.1s;
}

.animtion-ripple-container .ripple:nth-child(3) {
    width: 500px;
    height: 500px;
    opacity: 0.14;
    animation-delay: 2.2s;
}

.animtion-ripple-container .ripple:nth-child(4) {
    width: 500px;
    height: 500px;
    opacity: 0.1;
    animation-delay: 3.3s;
}

/* Color flip overlay */
.animtion-ripple-container .ripple::after {
    content: '';
    position: absolute;
    top: 10%;
    right: 10%;
    // transform: translate(-50%, -50%);
    width: 500px;
    height: 500px;
    border-radius: inherit;
    background: conic-gradient(from 0deg,
            rgba(88, 84, 255, 0) 0%,
            rgba(88, 84, 255, 0.22) 25%,
            rgba(88, 84, 255, 0) 50%,
            rgba(88, 84, 255, 0.16) 75%,
            rgba(88, 84, 255, 0) 100%);
    filter: blur(12px);
    pointer-events: none;
    animation: ripple-spin 14s linear infinite;
}

/* Twist and flip in place (no scaling) */
@keyframes ripple-twist {
    0% {
        transform: translate(-50%, -50%) rotate(0deg) skewX(0deg) skewY(0deg);
        opacity: 0.2;
        right: auto;
        left: 50%;
    }

    25% {
        transform: translate(-50%, -50%) translate(12px, -10px) rotate(8deg) skewX(6deg) skewY(-4deg);
        opacity: 0.24;
        right: auto;
        left: 50%;


    }

    50% {
        transform: translate(-50%, -50%) translate(-14px, 12px) rotate(-10deg) skewX(-7deg) skewY(5deg);
        opacity: 0.18;
        right: auto;
        left: 50%;


    }

    75% {
        transform: translate(-50%, -50%) translate(10px, 8px) rotate(6deg) skewX(5deg) skewY(-5deg);
        opacity: 0.16;
        right: auto;
        left: 50%;

    }

    100% {
        transform: translate(-50%, -50%) rotate(0deg) skewX(0deg) skewY(0deg);
        opacity: 0.2;
        right: auto;
        left: 50%;

    }
}

@keyframes ripple-spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@keyframes ripple-drift {
    0% {
        transform: translate(-50%, -50%) translate(0px, 0px) scale(1);
    }

    25% {
        transform: translate(-50%, -50%) translate(16px, -12px) scale(1.03);
    }

    50% {
        transform: translate(-50%, -50%) translate(-10px, 14px) scale(1.06);
    }

    75% {
        transform: translate(-50%, -50%) translate(12px, 10px) scale(1.02);
    }

    100% {
        transform: translate(-50%, -50%) translate(0px, 0px) scale(1);
    }
}
</style>
